"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AsyncTemplatesSettingsContainer;

var _react = _interopRequireDefault(require("react"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var _UILoadingDots = _interopRequireDefault(require("UIComponents/loading/UILoadingDots"));

var TemplatesSettingsContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./TemplatesSettingsContainer'
    /* webpackChunkName: "chunk-content-membership" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return _react.default.createElement(_UILoadingDots.default, {
      minHeight: 200
    });
  }
});

function AsyncTemplatesSettingsContainer(props) {
  return _react.default.createElement(TemplatesSettingsContainer, props);
}

module.exports = exports.default;